import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import { useNavigate } from 'react-router-dom';
import Axios from '../utils/axios';


const MyFooter = ({ handleSaveNew, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='primary'>Apply</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};

const DeliveryRegionModal = ({create, success}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [deliveryRegions, setDeliveryRegions] = useState([]);
  const navigate = useNavigate();

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  

  const handleSaveNew = () => {
    // addEntry();
    save();
    handleCancel();
  };

  const save = async () => {
    EventEmitter.dispatch('posorderdeliveryregion', form.getFieldValue('delivery_region_id'));
  }

  

  useEffect(() => {
    EventEmitter.subscribe('opendeliveryregion', info => {
      Axios.get('delivery-regions')
      .then(res => setDeliveryRegions(res.data))
      .catch(err => console.log(err))
      setIsModalOpen(info);
    });
    
    
    return () => {
      EventEmitter.unsubscribe('opendeliveryregion');
    }
  },[])

  const handleSaveClose = () => {
    save();
    handleCancel();
  }



  return (
    <Modal title="Delivery Region" className='p-0 ' open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveNew={handleSaveNew} handleSaveClose={handleSaveClose}/>}>
      <Form 
        form={form}
        className='pt-5 border-t-2 mt-3' 
        labelAlign='left'
        labelCol={{span: 8}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Delivery Region' name="delivery_region_id" className='font-semibold text-gray-800 mb-4' required>
          <Select options={deliveryRegions.map(region => ({value: region.id, label: region.name}))}/>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default DeliveryRegionModal;